export class alternativeList {
    holder:JQuery
    parentRow:string;
    idAttr:string;
    id:number;
    ids:Array<number>;
    mode:string; // solo or multi
    dataTable;

    constructor(holder:string, parentRow:string, idAttr:string, mode='solo', dataTable=false){
        this.holder = $(holder)
        this.parentRow = parentRow
        this.idAttr = idAttr
        this.dataTable = dataTable

        this.getIds();
        this.mode = mode
        
        this.addListener()
    }

    toggleBtn($btn:JQuery){
        $btn
        .toggleClass("btn-light-success")
        .toggleClass("text-success")
        .toggleClass("btn-light-danger")
        .toggleClass("text-danger")
        
    //    $btn.parents(this.parentRow).toggleClass("chosen")
    }

    addListener(){
        const self = this
        $(this.holder).on("click", ".choose", function(){
            const parent = $(this).parents(self.parentRow)
            const testId = parent.attr(self.idAttr)
    
    
            $(self.parentRow).each((ind, obj) => {
                $(obj).removeClass("chosen")
            })
    
        
    
            if (!$(this).hasClass("active")){
                parent.addClass("chosen")
                $(this).html("Abwählen")
            } else {
                $(this).html("Auswählen")
                self.id = Number(testId);
            }
    
            self.toggleBtn($(this))
            $(this).toggleClass("active")
    

            if (self.mode == 'solo'){
                self.deactivateAllButChosen(Number(testId))
            } else if (self.mode == 'multi'){
                self.ids = []
                self.getIds()
            }
        })

        $(document).on("click", ".alt-select-all", function(){
            if ($(this).hasClass("active")){
                $(this).removeClass("active")
                $(this).html("Alle auswählen")
                self.toggleBtn($(this))
                self.deactivateAllButChosen(0)
            } else {
                self.activateAll()
                $(this).addClass("active")
                $(this).html("Alle abwählen")
                self.toggleBtn($(this))
            }
        })

    }

    getIds(){
        const self = this;
        self.ids = []
        $(this.holder).find(".choose.active").each((ind, obj) => {
            const id = $(obj).parents(self.parentRow).attr(self.idAttr)
            self.ids.push(Number(id))
        })
        return self.ids;
    }

    activateAll(){
        const self = this;
        this.ids = []
        if (!this.dataTable){
            $(this.holder).find(".choose").each((ind, btn) => {
                self.ids.push(self.getId($(btn)))
                self.addBtn($(btn))
            })
        } else {
            // there is a datatable -> use it
            const nodes = this.dataTable.rows({page: 'all'}).nodes()
            nodes.each((node) => {
                let btn = $(node).find(".choose")
                self.ids.push(self.getId($(btn)))
                self.addBtn($(btn))
            })
        }
    }

    activateAllDatatable(){

    }

    getId($btn:JQuery){
        return Number($btn.parents(this.parentRow).attr(this.idAttr))
    }

    deactivateAllButChosen(testId:number){
        const self = this;
        if (!this.dataTable){
            $(this.holder).find(".choose").each((ind, obj) => {
                const objParent = $(obj).parents(self.parentRow)
                const objTestId = objParent.attr(self.idAttr)

                if (Number(objTestId) != Number(testId)){
                    self.removeBtn($(obj))
                }
            })
        } else {
            // there is a datatable -> use it
            const nodes = this.dataTable.rows({page: 'all'}).nodes()
            nodes.each((node) => {
                const objTestId = $(node).attr(self.idAttr)
                const btn = $(node).find(".choose")

                if (Number(objTestId) != Number(testId)){
                    self.removeBtn($(btn))
                }
            })
        }
    }

    addBtn($btn:JQuery){
        $btn.addClass("active")
        $btn.html("Abwählen")
        this.addButton($btn)
    }

    addButton($btn:JQuery){
        $btn.addClass("active")
        $btn.html("Abwählen")
        $btn
        .removeClass("btn-light-success")
        .removeClass("text-success")
        .addClass("btn-light-danger")
        .addClass("text-danger")
    }

    removeBtn($btn:JQuery){
        $btn.removeClass("active")
        .addClass("btn-light-success")
        .addClass("text-success")
        .removeClass("btn-light-danger")
        .removeClass("text-danger")
        .html("Auswählen")
    }
}